import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { useGetResponsiveAssets } from '../../hooks/useGetResponsiveAssets'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

/**
 * Illustration to show on the disclaimer screen when client first downloads the app
 */

const DisclaimerIllustrationPNG = styled(Image)<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

export const DisclaimerIllustration: FunctionComponent = () => {
  const { formatMessage } = useIntl()
  const {
    assets: { disclaimerIllustration },
  } = useTheme()

  const imageUrl = useGetResponsiveAssets(disclaimerIllustration?.assetNames ?? { defaultAsset: '' })

  const imageDimensions = { width: 280, height: 223 }
  if (imageUrl) {
    imageDimensions.width = 340
    imageDimensions.height = 280
  }

  return (
    <DisclaimerIllustrationPNG
      width={imageDimensions.width}
      height={imageDimensions.height}
      testID={`${tID('DisclaimerIllustration')}`}
      source={imageUrl ? { uri: imageUrl } : require('./../../assets/disclaimerIllustration.png')}
      ariaLabel={formatMessage({
        defaultMessage: 'Illustration of a two people sitting across from each other and talking',
        description: 'Accessibility label for illustration',
      })}
    />
  )
}
